import type { FC } from 'react'

import { Checkbox } from '@skytech/ui'

import type { AssignmentStatus } from './types'

import './EcomPolicyCheckbox.styles.scss'

/**
 * This is a custom checkbox with 3 states:
 * checked, not checked and partially checked
 */
export const EcomPolicyCheckbox: FC<{
  status: AssignmentStatus
  policyId: number
  onClick: () => void
}> = ({ status, policyId, onClick }) => (
  <Checkbox
    className={`policy-checkbox-custom ${status}`}
    checked={status !== 'not_assigned'}
    id={`policy-${policyId}`}
    onChange={onClick}
  />
)
